import { useControl } from "react-map-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

export default function DrawControl({ handleCreateEvent }) {
  useControl(
    ({ map }) => {
      const controlGl = new MapboxDraw({
        controls: {
          point: true,
          polygon: false,
          combine_features: false,
          uncombine_features: false,
        },
      });
      map.on("load", () => {
        map.addControl(controlGl);
      });
      map.on("draw.create", (e) => {
        const { features } = e;
        const lenFeatures = features.length;
        const lastFeature = features[lenFeatures - 1];
        handleCreateEvent(lastFeature);
      });
    },
    {
      position: "top-left",
    }
  );

  return null;
}
